var map = {
	"./compliance-1.jpg": 5050,
	"./esg-governance-structure.png": 1469,
	"./governence-section-one.jpg": 4691,
	"./journey-1.jpg": 9197,
	"./journey.jpg": 7750,
	"./miles.jpg": 5193,
	"./risk-management.png": 8323,
	"./saudi-green.jpg": 55,
	"./stakeholder-1.jpg": 675,
	"./sustainable-finance-government.png": 489,
	"./water-in-desert.jpg": 6734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6418;